import React from 'react';
import { Lock } from 'lucide-react';

// Professional "locked feature" overlay. Wraps a teaser (blurred, non-interactive
// preview of the real component) with a centered unlock CTA. Use `variant="panel"`
// for full cards (regime, pair, seasonal) and `variant="inline"` for small chips.
const LockOverlay = ({
  title = 'Locked',
  subtitle = 'Sign in to unlock',
  onRequestLogin,
  children,
  variant = 'panel',
  minHeight = 130,
}) => {
  return (
    // h-full so on desktop it fills its rail (the blurred teaser shows through);
    // the teaser is ABSOLUTE so it never stretches the box — on phone the box
    // stays compact (just the lock card), it doesn't inflate to the full height
    // of the hidden component behind it.
    <div
      className="relative overflow-hidden rounded-lg h-full bg-gray-50 dark:bg-gray-800"
      style={{ minHeight }}
    >
      {/* Teaser preview — blurred, dimmed, clipped, non-interactive */}
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden blur-[3px] opacity-40 saturate-50">
        {children}
      </div>

      {/* Frosted lock layer */}
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5 bg-white/55 dark:bg-gray-900/55 backdrop-blur-[1px] text-center px-4 py-3">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-900/80 text-white shadow">
          <Lock size={15} />
        </div>
        <div>
          <div className="text-sm font-semibold text-gray-900 dark:text-white leading-tight">{title}</div>
          {subtitle && (
            <div className="text-[11px] text-gray-600 dark:text-gray-300">{subtitle}</div>
          )}
        </div>
        <button
          onClick={onRequestLogin}
          className={`mt-0.5 rounded-full bg-emerald-600 px-4 py-1.5 font-medium text-white shadow-sm transition-colors hover:bg-emerald-700 ${
            variant === 'inline' ? 'text-[11px] px-3 py-1' : 'text-xs'
          }`}
        >
          Log in to unlock
        </button>
      </div>
    </div>
  );
};

export default LockOverlay;
